import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import { Form, InputGroup } from 'react-bootstrap';
import moment from 'moment';
import { IoCloseSharp } from 'react-icons/io5';
import viewIcon from "../../assets/images/view.svg";
import { getSentLogListing } from '../../api/context/report';


const queueDatatableCustomStyles = {
    headCells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontWeight: '600',
            fontSize: '14px',

        },
    },
    cells: {
        style: {
            display: "flex",
            // justifyContent: "center",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
        },
    },

};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #EBEBEB",
        padding: '6px',
    }),
};



const SentReport = () => {

    const navigate = useNavigate()

    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(25);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('')
    const [update, setUpdate] = useState(false);
    const [sentLog, setSentLog] = useState([]);

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => page == 0 ? index + 1 : (page - 1) * limit + index + 1,
            width: '90px',
            center: true
        },
        {
            id: 'template',
            name: 'Template',
            selector: (row) => row?.template,
            cell: (row) => <Tooltip title={row?.template} disableInteractive placement='top'><div className='ellipse_email'>{row?.template}</div></Tooltip>,
            grow: 0.4,
            minWidth: '200px',
            reorder: true,
            left: true,
        },
        {
            id: 'created_date',
            name: 'Date Sent',
            selector: (row) => moment(row?.created_date).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.created_date).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                    <div className='ellipse_email'>{moment(row?.created_date).format('DD/MM/YYYY, hh:mm a')}</div>
                </Tooltip>
            ),
            grow: 1,
            minWidth: '120px',
            reorder: true,
        },
        // {
        //     id: 'updatedAt',
        //     name: 'Updated Date',
        //     selector: (row) => moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a'),
        //     cell: (row) => (
        //         <Tooltip title={moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
        //             <div className='ellipse_email'>{moment(row?.modified_date).format('DD/MM/YYYY, hh:mm a')}</div>
        //         </Tooltip>
        //     ),
        // },

        {
            name: "ACTION",
            cell: (row) =>
                <div>

                    <div className='d-flex flex-row gap-3' role='button'>
                    <Tooltip title="View" disableInteractive placement="top">
                  <img
                    src={viewIcon}
                    alt=""
                    onClick={() => navigate('/sent-report-details', { state: { reportId: row.id } })}
                  />
                </Tooltip>
                    </div>

                </div>,
            grow: 0.1,
            minWidth: '200px',
            reorder: true,
            center: true
        },
    ];



    const fetchSentLogListing = async () => {
        setLoading(true);
        const skip = page != 0 ? (page - 1) * limit : 0;
        getSentLogListing({ skip, limit, search })((response) => {
            console.log(response, 'response');
            if (response?.status_code === 200) {
                setSentLog(response?.data?.results);
                setTotalRows(response?.data?.count);
            } else {
                setSentLog([]);
            }
            setLoading(false);
        });
    };


    const handleSearchData = (e) => {
        setSearch(e.target.value);
        if (e.target.value == '') {
            setUpdate(!update);
        }
    }

    const handleClearSearch = () => {
        setSearch('');
        setUpdate(!update);
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (search != '') {
                setUpdate(!update)
            }

        }, 800);
        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(0);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };


    useEffect(() => {
        setLoading(true);
        fetchSentLogListing();

    }, [update]);



    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">Sent Reports</h4>
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="request_wrapper_filter">
                        <div className='dataTable-left'>
                            <InputGroup className="">
                                <Form.Control
                                    placeholder="Search"
                                    aria-label="Search"
                                    aria-describedby="basic-addon2"
                                    value={search}
                                    onChange={handleSearchData}
                                />
                                {search && (
                                    <InputGroup.Text id="basic-addon3" onClick={handleClearSearch} style={{ cursor: "pointer" }}><IoCloseSharp /></InputGroup.Text>
                                )}
                            </InputGroup>
                        </div>
                    </div>
                    <div className="d_grid_wrapper"></div>
                </div>
                <div className='col-12'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square>
                            <div>
                                <DataTable
                                    columns={columns}
                                    data={sentLog}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                />
                            </div>
                        </Paper>
                    </Box>

                </div>

            </div>
        </>
    )
}

export default SentReport